module.exports = __webpack_public_path__ + "static/media/exportNew.0e4aa9c0.svg";